import React, { Fragment } from 'react';
import { SvgIcon, SvgIconProps } from '../components';

export default function BackBurgerTwoTone(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <Fragment>
        <path d="M.79 3.586h18.385c.413 0 .79-.414.79-.793 0-.414-.412-.793-.79-.793H.79C.378 2 0 2.414 0 2.793c0 .38.412.793.79.793zm18.317 5.413H6.597c-.411 0-.79.413-.79.793 0 .413.413.793.79.793h12.51c.412 0 .79-.414.79-.793 0-.38-.31-.793-.79-.793zm.103 7.067H.928c-.413 0-.79.414-.79.793 0 .414.412.793.79.793H19.21c.412 0 .79-.414.79-.793 0-.413-.412-.793-.79-.793zM4.364 6.275L0 9.619l4.296 3.413.068-6.757z" />
      </Fragment>
    </SvgIcon>
  );
}
